<template>
  <div class="col-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item
        v-if="options.menuName !== '搜索' && options.menuName !== '移动端导航栏'"
        @mousedown.native="collapseMouseDown($event, '1')"
        title="基础设置"
        name="1"
        class="padding0"
      >
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <collapsibleItem
            :name="collapse.top.title"
            :type="collapse.top.type"
            :is-active="collapse.top.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 1)"
          >
            <div slot="heading">{{ collapse.top.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 1) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowTop">显示标题栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('top')"></i>
                </div>
                <div v-if="isShowTop" class="content-item">
                  <slider-and-input
                    class=""
                    :value.sync="topHeight"
                    title="高度"
                    :sliderMax="500"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowTop">
                  <div
                    v-for="(titleComponent, index) in titleComponents[0].elementOptions"
                    :key="index"
                    class="content-item"
                    v-show="!(pageType === 'listPage' && titleComponent.type === 'more')"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 0, titleComponent)"
                      >{{ titleComponent.title }}
                    </el-checkbox>
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick(titleComponent.type)"></i>
                    <el-checkbox
                      v-show="titleComponent.title === '显示分类'"
                      class="mt12"
                      :value.sync="titleComponent.showAllType"
                      @change="showAllTypeHandle($event, 0, titleComponent)"
                      >{{ titleComponent.showAllTypeTitle }}</el-checkbox
                    >
                  </div>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.left.title"
            :type="collapse.left.type"
            :is-active="collapse.left.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 2)"
          >
            <div slot="heading">{{ collapse.left.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 2) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowLeft">显示左侧栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('left')"></i>
                </div>
                <div v-if="isShowLeft" class="content-item">
                  <slider-and-input
                    class=""
                    :value.sync="leftWidth"
                    title="宽度"
                    :sliderMax="500"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowLeft">
                  <div
                    v-for="(titleComponent, index) in titleComponents[2].elementOptions"
                    :key="index"
                    class="content-item"
                    v-show="!(pageType === 'listPage' && titleComponent.type === 'more')"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 2, titleComponent)"
                      >{{ titleComponent.title }}
                    </el-checkbox>
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick(titleComponent.type)"></i>
                    <el-checkbox
                      v-show="titleComponent.title === '显示分类'"
                      class="mt12"
                      :value.sync="titleComponent.showAllType"
                      @change="showAllTypeHandle($event, 2, titleComponent)"
                      >{{ titleComponent.showAllTypeTitle }}</el-checkbox
                    >
                  </div>
                  <template v-if="request_prefix.includes('app')">
                    <cx-check-box :value.sync="isDrawerModeL">抽屉模式</cx-check-box>
                    <template v-if="isDrawerModeL">
                      <cx-check-box :value.sync="drawerL">显示抽屉</cx-check-box>
                      <cx-select :value.sync="inBodyL" :selectOptions="drawerSelectOptions" title="抽屉位置" />
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.right.title"
            :type="collapse.right.type"
            :is-active="collapse.right.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 3)"
          >
            <div slot="heading">{{ collapse.right.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 3) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowRight">显示右侧栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('right')"></i>
                </div>
                <div v-if="isShowRight" class="content-item">
                  <slider-and-input
                    class=""
                    :value.sync="rightWidth"
                    title="宽度"
                    :sliderMax="500"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowRight">
                  <div
                    v-for="(titleComponent, index) in titleComponents[3].elementOptions"
                    :key="index"
                    class="content-item"
                    v-show="!(pageType === 'listPage' && titleComponent.type === 'more')"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 3, titleComponent)"
                      >{{ titleComponent.title }}
                    </el-checkbox>
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick(titleComponent.type)"></i>
                    <el-checkbox
                      v-show="titleComponent.title === '显示分类'"
                      class="mt12"
                      :value.sync="titleComponent.showAllType"
                      @change="showAllTypeHandle($event, 3, titleComponent)"
                      >{{ titleComponent.showAllTypeTitle }}</el-checkbox
                    >
                  </div>
                  <template v-if="request_prefix.includes('app')">
                    <cx-check-box :value.sync="isDrawerModeR">抽屉模式</cx-check-box>
                    <template v-if="isDrawerModeR">
                      <cx-check-box :value.sync="drawerR">显示抽屉</cx-check-box>
                      <cx-select :value.sync="inBodyR" :selectOptions="drawerSelectOptions" title="抽屉位置" />
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.bottom.title"
            :type="collapse.bottom.type"
            :is-active="collapse.bottom.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 4)"
          >
            <div slot="heading">{{ collapse.bottom.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 4) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowBottom">显示底部栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('bottom')"></i>
                </div>
                <div v-if="isShowBottom" class="content-item">
                  <slider-and-input
                    class=""
                    :value.sync="bottomHeight"
                    title="高度"
                    :sliderMax="500"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowBottom">
                  <div
                    v-for="(titleComponent, index) in titleComponents[1].elementOptions"
                    :key="index"
                    class="content-item"
                    v-show="!(pageType === 'listPage' && titleComponent.type === 'more')"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 1, titleComponent)"
                      >{{ titleComponent.title }}
                    </el-checkbox>
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick(titleComponent.type)"></i>
                    <el-checkbox
                      v-show="titleComponent.title === '显示分类'"
                      class="mt12"
                      :value.sync="titleComponent.showAllType"
                      @change="showAllTypeHandle($event, 1, titleComponent)"
                      >{{ titleComponent.showAllTypeTitle }}</el-checkbox
                    >
                  </div>
                </template>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="request_prefix !== 'bigScreen' && !preComponent && !!options.appId"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="子页面设置"
        name="2"
        class="padding0"
      >
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <collapsibleItem
            :name="collapse.list.title"
            :type="collapse.list.type"
            :is-active="collapse.list.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 5)"
          >
            <div slot="heading">{{ collapse.list.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 5) > -1">
                <div class="cover layoutConfig-card mt8">
                  <img class="img-box" :src="currentListPageCover" />
                  <div class="footer">
                    <div :title="currentListPageTitle" class="title">{{ currentListPageTitle }}</div>
                  </div>
                </div>
                <div v-if="options.menuName != '搜索'" class="mt8 mb12 content-item">
                  <el-checkbox v-model="listPageOpenBlank">新页面打开</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('open')"></i>
                </div>
                <div
                  :class="isListPageEditStatus ? 'is_disabled childPageSettingBtn mt8' : 'childPageSettingBtn mt8'"
                  @click="editPageHandle(true)"
                >
                  <span v-if="isListPageEditStatus" class="icon icon-portal-loading1"></span>
                  <span>{{ subpageSetting.listPageIsUseSystemTemplate ? "查看" : "编辑" }}列表页</span>
                </div>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.detail.title"
            :type="collapse.detail.type"
            :is-active="collapse.detail.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 6)"
          >
            <div slot="heading">{{ collapse.detail.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 6) > -1">
                <div class="cover layoutConfig-card mt8">
                  <img class="img-box" :src="currentDetailPageCover" />
                  <div class="footer">
                    <div :title="currentDetailPageTitle" class="title">{{ currentDetailPageTitle }}</div>
                  </div>
                </div>
                <div class="mt8 mb12 content-item">
                  <el-checkbox v-model="detailPageOpenBlank">新页面打开</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('open')"></i>
                </div>
                <div
                  :class="[
                    isDetailPageEditStatus ? 'is_disabled childPageSettingBtn mt8' : 'childPageSettingBtn mt8',
                    navAllDataEmpty ? 'disabledBtn' : '',
                  ]"
                  @click="editDetailPageHandle(true)"
                >
                  <span v-if="isDetailPageEditStatus" class="icon icon-portal-loading1"></span>
                  <span>{{ subpageSetting.detailPageIsUseSystemTemplate ? "查看" : "编辑" }}详情页</span>
                </div>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="
          request_prefix !== 'bigScreen' &&
          // pageType !== 'listPage' &&
          (!!options.appId || multiImageDetail) &&
          options.menuName != '搜索' &&
          options.menuName !== '移动端导航栏'
        "
        @mousedown.native="collapseMouseDown($event, '4')"
        title="高级设置"
        name="4"
        class="padding0"
      >
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
          <collapsibleItem
            :name="collapse.advanced.title"
            :type="collapse.advanced.type"
            :is-active="collapse.advanced.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 7)"
          >
            <div slot="heading">{{ collapse.advanced.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 7) > -1">
                <div v-if="!multiImageDetail" class="content-item">
                  <el-checkbox v-model="openDataLimit">数据访问限制</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick('dataLimit')"></i>
                  <div class="layoutConfig-card mt8" v-if="openDataLimit">
                    <div class="config-content">
                      <el-radio-group v-model="checkIp">
                        <div class="content-item mb12">
                          <el-radio :label="1">仅登录后可访问</el-radio>
                        </div>
                        <div class="content-item mb12">
                          <el-radio :label="2">仅IP内可访问</el-radio>
                        </div>
                        <div class="content-item mb12">
                          <el-radio :label="3">IP内可访问，IP外需要登录后访问</el-radio>
                        </div>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
                <div v-if="!multiImageDetail" class="content-item mt12">
                  <el-checkbox v-model="openDataPush">数据推送</el-checkbox>
                  <div v-if="openDataPush" class="childPageSettingBtn mt12" @click="showDialogForDataPush = true">
                    <span class="icon icon-portal-setting1"></span>
                    <span>配置数据推送</span>
                  </div>
                </div>
                <div v-if="!multiImageDetail" class="content-item mt12">
                  <el-checkbox v-model="openSensitiveWords">敏感词审核</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick('words')"></i>
                </div>
                <div v-if="!multiImageDetail" class="content-item mt12">
                  <el-checkbox v-model="deliverMhParams">携带系统参数</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick('MhParams')"></i>
                </div>
                <div class="content-item mt12">
                  <el-checkbox v-model="openHideEmptyCell">隐藏空白数据</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('hide')"></i>
                </div>
                <div class="content-item mt12">
                  <el-checkbox v-model="noDataHideComponent">数据为空时隐藏组件</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('hide')"></i>
                </div>
                <div class="content-item mt12 ml24" v-if="noDataHideComponent && isSingleCell">
                  <el-checkbox v-model="noDataShowLayout">隐藏布局和通栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('hide')"></i>
                </div>
                <div class="content-item mt12" v-if="!turnOnScroll">
                  <el-checkbox v-model="openCustomRenderOrder">{{ collapse.order.title }}</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('order')"></i>
                  <div class="mt12" v-if="openCustomRenderOrder">
                    <div class="childPageSettingBtn" @click="editCellOrder">
                      <span class="icon icon-portal-setting1"></span>
                      <span>配置顺序</span>
                    </div>
                  </div>
                </div>
                <div class="content-item mt12">
                  <el-checkbox v-model="emptyDataShowLocal">数据为空时显示以下内容</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('empty')"></i>
                </div>
                <div v-if="emptyDataShowLocal" class="mt12">
                  <cx-slider label="" :value.sync="sliderType" :options="sliderTypeOptions" />
                  <div v-if="sliderType === 'text'" class="">
                    <div class="mt16 text_content">
                      <span>文字样式</span>
                      <!-- 字体和颜色/字重和字号 -->
                      <text-setting-update
                          class="mb16 mt6 nextlinemt8"
                          :fontColor.sync="emptyFontColor"
                          :fontFamily.sync="emptyFontFamily"
                          :fontSize.sync="emptyFontSize"
                          :fontWeight.sync="emptyFontWeight"
                      />
                    </div>
                    <el-input class="mt8" v-model="emptyContent" placeholder="请输入" type="text"></el-input>
                  </div>
                  <div v-else class="mt16 image_content">
                    <img-upload
                        :imgSrc.sync="emptyImgSrc"
                        :defaultImg="defaultImgBg"
                        :showDel="false"
                        :maxSize="1"
                    ></img-upload>
                    <img-crop class="mt8" :clipSize.sync="emptyImgClipSize" :repeatType.sync="emptyImgRepeatType" :alignType.sync="emptyImgAlignType" />
                    <div class="verticallyCenter mt12 mb16">
                      <span class="mr16 fs14">尺寸</span>
                      <div class="verticallyCenter mr16 flex1">
                        <single-input
                            class="input-size"
                            placeholder="-"
                            :value.sync="emptyImgWidth"
                            :min="1"
                            inputSuffixs="宽"
                        />
                      </div>
                      <div class="verticallyCenter flex1">
                        <single-input
                            class="input-size"
                            placeholder="-"
                            :value.sync="emptyImgHeight"
                            :min="1"
                            inputSuffixs="高"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content-item mt12">
                  <el-checkbox v-model="diffCategory">组件分类样式独立</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('category')"></i>
                </div>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box" v-if="explainImgSrc || explainVideoSrc">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
    <!--数据推送设置弹框 --- 待后端接口完善后放出来-->
    <el-dialog
      title="配置数据推送"
      :visible.sync="showDialogForDataPush"
      :modal-append-to-body="false"
      custom-class="dataPushDialog"
    >
      <div class="verticallyCenter">
        <span class="width76 mr24">接口地址</span>
        <el-input
          class="flex1"
          v-model="interfacePushRule.url"
          placeholder="请输入https://或http://开头的链接地址
"
        ></el-input>
      </div>
      <div class="mt16 verticallyCenter">
        <span class="width76 mr24">触发条件</span>
        <el-checkbox v-model="newDataToPush" :label="1">新增数据时</el-checkbox>
        <el-checkbox v-model="editDataToPush" :label="2">修改数据时</el-checkbox>
      </div>
      <div class="mt16 verticallyCenter">
        <span class="width76 mr24">推送内容</span>
        <el-radio-group v-model="interfacePushRule.method">
          <el-radio :label="0" class="mr24">全部数据</el-radio>
          <el-radio :label="1">置顶数据</el-radio>
        </el-radio-group>
      </div>
      <div class="mt16 verticallyCenter push-history-link" @click.stop="toDataPushPage">
        <span class="mr2">查看推送记录</span>
        <span class="icon-portal-right-up fs14"></span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDialogForDataPush = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateDataPushSet">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  findTabs,
  replaceUrlParam,
  handleFindLayoutComponentBoxOptions,
  handleFindLayoutComponentAllUid,
  simpleDeepClone
} from "utils"
import { layout_title_drawer_button_children } from "materials/button/menus"
import {
  createSubPageHandle,
  updateSubPageMapping,
  addSubPageMapping
} from "utils/updateData/publicDataUtils/subPageUpdateData.js"
import defaultImgBg from "assets/images/empty_img_bg.png"
import defaultImgEmpty from "assets/images/img-null-data-light.png"
import { CATEGORY_MODE } from "@/consts/index.js"

export default {
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  watch: {
    openDataLimit: {
      handler: function (val) {
        this.highSet()
      },
      deep: false
    },
    openSensitiveWords: {
      handler: function (val) {
        this.highSet()
      },
      deep: false
    },
    deliverMhParams: {
      handler: function (val) {
        this.highSet()
      },
      deep: false
    },
    checkIp: {
      handler: function () {
        this.highSet()
      },
      deep: false
    },
    openDataPush(newVal, o) {
      this.interfacePushRule.status = newVal
      this.updateDataPushSet()
    },
    "subpageSetting.listPageTemplateId": {
      handler: function (val) {
        this.getListSubpageInfo(val)
      },
      deep: false
    },
    "subpageSetting.detailPageTemplateId": {
      handler: function (val) {
        this.getDetailSubpageInfo(val)
      },
      deep: false
    },
    editDataToPush(newVal, oldVal) {
      let dot = this.newDataToPush && this.editDataToPush ? "," : ""
      this.interfacePushRule.addAndUpdateRule = `${this.newDataToPush ? "1" : ""}${dot}${
        this.editDataToPush ? "2" : ""
      }`
    },
    newDataToPush(newVal, oldVal) {
      let dot = this.newDataToPush && this.editDataToPush ? "," : ""
      this.interfacePushRule.addAndUpdateRule = `${this.newDataToPush ? "1" : ""}${dot}${
        this.editDataToPush ? "2" : ""
      }`
    }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3", "4"],
      collapseActiveNames: ["1", "2", "3", "4"],
      drawerSelectOptions: [
        {
          label: "页面",
          value: true
        },
        {
          label: "组件",
          value: false
        }
      ],
      collapse: {
        top: {
          title: "标题栏",
          type: "top",
          isActive: true
        },
        bottom: {
          title: "底部栏",
          type: "bottom",
          isActive: true
        },
        left: {
          title: "左侧栏",
          type: "left",
          isActive: true
        },
        right: {
          title: "右侧栏",
          type: "right",
          isActive: true
        },
        list: {
          title: "列表页",
          type: "list",
          isActive: true
        },
        detail: {
          title: "详情页",
          type: "detail",
          isActive: true
        },
        advanced: {
          title: "数据设置",
          type: "advanced",
          isActive: true
        },
        order: {
          title: "自定义数据顺序",
          type: "order",
          isActive: true
        }
      }, // 用来存放当前数据组和图例设置里面的展开收起状态
      collapseDataActiveNames: ["0", "1", "2", "3", "4", "5", "6", "7"],
      // 用户配置项回显 // 先给一个默认值
      titleComponents: [
        {
          directionIndex: 0,
          elementOptions: [
            {
              type: "classification",
              title: "显示分类",
              elementInLayoutId: 0,
              isShow: true,
              disabled: false,
              showAllType: false,
              showAllTypeTitle: "显示全部分类数据"
            },
            {
              type: "more",
              title: "显示更多按钮",
              elementInLayoutId: 1,
              isShow: true,
              disabled: false
            }
          ]
        },
        {
          directionIndex: 1,
          elementOptions: [
            {
              type: "classification",
              title: "显示分类",
              elementInLayoutId: 0,
              isShow: false,
              disabled: true,
              showAllType: false,
              showAllTypeTitle: "显示全部分类数据"
            },
            {
              type: "more",
              title: "显示更多按钮",
              elementInLayoutId: 1,
              isShow: false,
              disabled: true
            },
            {
              type: "pagination",
              title: "显示分页",
              elementInLayoutId: 2,
              isShow: true,
              disabled: false
            }
          ]
        },
        {
          directionIndex: 2,
          elementOptions: [
            {
              type: "classification",
              title: "显示分类",
              elementInLayoutId: 0,
              isShow: false,
              disabled: true,
              showAllType: false,
              showAllTypeTitle: "显示全部分类数据"
            },
            {
              type: "more",
              title: "显示更多按钮",
              elementInLayoutId: 1,
              isShow: false,
              disabled: true
            }
          ]
        },
        {
          directionIndex: 3,
          elementOptions: [
            {
              type: "classification",
              title: "显示分类",
              elementInLayoutId: 0,
              isShow: false,
              disabled: true,
              showAllType: false,
              showAllTypeTitle: "显示全部分类数据"
            },
            {
              type: "more",
              title: "显示更多按钮",
              elementInLayoutId: 1,
              isShow: false,
              disabled: true
            }
          ]
        }
      ],
      listPageData: {},
      detailPageData: {},
      showNavMenu: true,
      showApplicationName: true,
      showSearchComponent: true,
      showBreadCrumbs: true,
      currentListPageCover: "",
      currentListPageTitle: "",
      currentDetailPageCover: "",
      currentDetailPageTitle: "",
      publicId: null,
      subPageSettingIndex: 0,
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      isListPageEditStatus: false,
      isDetailPageEditStatus: false,
      getAllTabsIsCheckedAll: false,
      allTabsIsCheckedAll: false,
      allTabs: [],
      bottomPaginationShow: false,
      showDialogForDataPush: false,
      interfacePushRule: {
        addAndUpdateRule: "", //1表示新增时，2表示修改时
        engineInstanceId: this.options.engineInstanceId_10, //对应应用的engineInstanceId
        id: null, //有则修改，为空为新增
        method: 0, //0表示全部数据，1表示置顶数据
        pushType: "1", //推送置接口固定为1
        status: this.options.openDataPush, //true开启推送，false关闭
        url: ""
      },
      editDataToPush: false,
      newDataToPush: false,
      navAllDataEmpty: false,
      sliderType: "text",
      sliderTypeOptions: [
        {
          value: "text",
          title: "文字",
        },
        {
          value: "image",
          title: "图片",
        }
      ],
      defaultImgBg: defaultImgBg,
      defaultImgEmpty: defaultImgEmpty,
    }
  },
  computed: {
    // 预设组件
    preComponent() {
      const rectAttr = this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        "rect"
      )
      return rectAttr.preComponent
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      if (this.ids.elementInAutoLayoutId !== undefined) {
        return this.getAttrById(this.$store.state[this.request_prefix], this.ids, "elementInAutoLayout")
      }
      return this.getRectAttribute.call(this, this.ids).options
    },
    isShowTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[0].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 0, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
        this.checkSubComponent(0, newVal)
      }
    },
    topHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    isShowBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[1], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[1].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 1, item)
          })
        } else {
          // 找出底部栏的分页组件
          const pagination = this.titleComponents[1].elementOptions.find(item => {
            return item.type === "pagination"
          })
          this.checkboxDisplayHandle(true, 1, pagination)
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          directionIndex: 1,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
        this.checkSubComponent(1, newVal)
      }
    },
    bottomHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[1], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          directionIndex: 1,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    isShowLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[2], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[2].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 2, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          directionIndex: 2,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
        this.checkSubComponent(2, newVal)
      }
    },
    leftWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[2], "width", "width", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          directionIndex: 2,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "width", false, false, completeParam)
      }
    },
    isShowRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[3], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[3].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 3, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          directionIndex: 3,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
        this.checkSubComponent(3, newVal)
      }
    },
    rightWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[3], "width", "width", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          directionIndex: 3,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "width", false, false, completeParam)
      }
    },
    isDrawerModeL: {
      get() {
        const val = this.checkAndSetPrimaryVal(this.options, "isDrawerModeL", "isDrawerModeL")
        const hasBtn = this.options.titleOptions[0].elementOptions.find(item => item.options.drawerPosition === "L")
        if (val === true) {
          //将左侧的多级下拉改为点击激活
          this.checkMenuTriggerType("L")
          //检测自由布局头部框内是否有按钮开关，如果没有就要初始化一个
          if (hasBtn === undefined) {
            this.initDrawerBtn("L")
          }
          //显示左侧栏
          this.isShowLeft = true
        } else {
          //检测自由布局头部框内是否有按钮开关，如果有就要删除
          if (hasBtn !== undefined) {
            this.delDrawerBtn(hasBtn.elementInLayoutId)
          }
        }
        return val
      },
      set(val) {
        if (!val) {
          // 关闭抽屉模式时也关闭显示抽屉 解决预览页关闭了抽屉模式还是会显示遮罩
          this.$changeOptionsEV([val, val], ["isDrawerModeL", "drawerL"])
        } else {
          this.$changeOptionsEV(val, "isDrawerModeL")
        }
      }
    },
    drawerL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerL", "drawerL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerL")
      }
    },
    inBodyL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "inBodyL", "inBodyL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyL")
      }
    },
    inBodyR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "inBodyR", "inBodyR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyR")
      }
    },
    isDrawerModeR: {
      get() {
        const val = this.checkAndSetPrimaryVal(this.options, "isDrawerModeR", "isDrawerModeR")
        const hasBtn = this.options.titleOptions
          .find(it => it.type === "top")
          .elementOptions.find(item => item.options.drawerPosition === "R")
        if (val === true) {
          //将右侧的多级下拉改为点击激活
          this.checkMenuTriggerType("R")
          //检测自由布局头部框内是否有按钮开关，如果没有就要初始化一个
          if (hasBtn === undefined) {
            this.initDrawerBtn("R")
          }
          //显示右侧侧栏
          this.isShowRight = true
        } else {
          //检测自由布局头部框内是否有按钮开关，如果有就要删除
          if (hasBtn !== undefined) {
            this.delDrawerBtn(hasBtn.elementInLayoutId)
          }
        }
        return val
      },
      set(val) {
        if (!val) {
          // 关闭抽屉模式时也关闭显示抽屉 解决预览页关闭了抽屉模式还是会显示遮罩
          this.$changeOptionsEV([val, val], ["isDrawerModeR", "drawerL"])
        } else {
          this.$changeOptionsEV(val, "isDrawerModeR")
        }
      }
    },
    drawerR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerR", "drawerR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerR")
      }
    },
    turnOnScroll: {
      get() {
        return this.options.turnOnScroll || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "turnOnScroll", false)
      }
    },
    openDataLimit: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "openDataLimit", "openDataLimit", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "openDataLimit", false)
      }
    },
    checkIp: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "checkIp", "checkIp", "1")
      },
      set(val) {
        console.log("val :>>", val)

        this.$changeOptionsEV(val, "checkIp", false)
      }
    },
    openSensitiveWords: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "openSensitiveWords", "openSensitiveWords", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "openSensitiveWords", false)
      }
    },
    openDataPush: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "openDataPush", "openDataPush", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "openDataPush", false)
      }
    },
    //  是否开启携带系统参数
    deliverMhParams: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "deliverMhParams", "deliverMhParams", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "deliverMhParams", false)
      }
    },
    // 是否开启隐藏空数据的单元格 默认开启
    openHideEmptyCell: {
      get() {
        return this.options.hasOwnProperty("openHideEmptyCell") ? this.options.openHideEmptyCell : true
      },
      set(val) {
        this.$changeOptionsEV(val, "openHideEmptyCell", false)
      }
    },
    isSingleCell() {
      let isSingleCell = false
      // 翻页模版不展示 隐藏通栏和布局
      if (this.$store.state[this.request_prefix].page.isPhoneFullScreen) {
        return isSingleCell
      }
      let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      for (let i = 0; i < pageLayoutList.length; i++) {
        if (pageLayoutList[i].layout.rows[0].rectIds?.indexOf(this.ids.rect_id) > -1) {
          if (pageLayoutList[i].layout.rows.length === 1 && pageLayoutList[i].layout.rows[0].rectIds.length === 1) {
            isSingleCell = true
          }
          break
        }
      }
      return isSingleCell
    },
    // 是否开启无数据隐藏组件
    noDataHideComponent: {
      get() {
        return this.options.hasOwnProperty("noDataHideComponent") ? this.options.noDataHideComponent : false
      },
      set(val) {
        if (!val) {
          this.$changeOptionsEV([val, false], ["noDataHideComponent", "noDataShowLayout"], false)
        } else {
          this.$changeOptionsEV(val, "noDataHideComponent", false)
        }
      }
    },
    // 该组件无数据时，是否隐藏布局。多行多列不能隐藏
    noDataShowLayout: {
      get() {
        return this.options.hasOwnProperty("noDataShowLayout") ? this.options.noDataShowLayout : false
      },
      set(val) {
        this.$changeOptionsEV(val, "noDataShowLayout", false)
      }
    },
    // 是否开启自定义数据渲染顺序
    openCustomRenderOrder: {
      get() {
        return this.options.renderOrder ? true : false
      },
      set(val) {
        let newVal = val ? {} : null
        this.$changeOptionsEV(
          newVal,
          "renderOrder",
          null,
          false,
          {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            path: this.ids.path,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId
          },
          true
        )
        if (!newVal) {
          // 清空自定义顺序  模拟点击
          let getDataBtn = document.getElementsByClassName("toolbar")[0].getElementsByClassName("getDataBtn")
          if (getDataBtn.length > 0) {
            getDataBtn[0].click()
          }
        }
      }
    },
    /**
     * ========列表页配置项===========
     */
    listPageSetting() {
      if (!this.options.appId) return
      const index = this.$store.state[this.request_prefix].page?.subPages?.findIndex(
        item => item.appId === this.options.appId
      )
      if (typeof index === "undefined" || index === -1) return
      return this.$store.state[this.request_prefix].page?.subPages[index].listPageSetting
    },
    listPageOpenBlank: {
      get() {
        return this.listPageSetting?.hasOwnProperty("listPageOpenBlank") ? this.listPageSetting.listPageOpenBlank : true
      },
      set(val) {
        if (this.subPageSettingIndex === -1) return
        let temp = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
        temp[this.subPageSettingIndex].listPageSetting.listPageOpenBlank = val
        updateSubPageMapping.call(this, temp)
        // 每次更新完子页面配置后需要手动触发一次保存
        this.saveDataHandle()
      }
    },

    /**
     * ========详情页配置项===========
     */
    detailPageSetting() {
      if (!this.options.appId) return
      const index = this.$store.state[this.request_prefix].page?.subPages?.findIndex(
        item => item.appId === this.options.appId
      )
      if (typeof index === "undefined" || index === -1) return
      return this.$store.state[this.request_prefix].page?.subPages[index].detailPageSetting
    },
    detailPageOpenBlank: {
      get() {
        return this.detailPageSetting?.hasOwnProperty("detailPageOpenBlank")
          ? this.detailPageSetting.detailPageOpenBlank
          : true
      },
      set(val) {
        if (this.subPageSettingIndex === -1) return
        let temp = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
        temp[this.subPageSettingIndex].detailPageSetting.detailPageOpenBlank = val
        updateSubPageMapping.call(this, temp)
        // 每次更新完子页面配置后需要手动触发一次保存
        this.saveDataHandle()
      }
    },
    // 判断当前是双端环境
    isDounbleEnd() {
      const page = this.$store.state[this.request_prefix].page
      if (page.isPhoneFullScreen || page.isOnlyH5Template) {
        return false
      }
      return true
    },
    subpageSetting() {
      const subPages = this.$store.state[this.request_prefix].page.subPages || []
      const subPage = subPages.find(item => item.appId === this.options.appId) || {}
      return subPage
    },
    isSearchComponent() {
      return this.getOptions.pluginName?.includes("searchComponentPlugin")
    },
    emptyDataShowLocal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyDataShowLocal", "emptyDataShowLocal", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyDataShowLocal", false, null)
      }
    },
    emptyContent: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyContent", "emptyContent", "暂无数据")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyContent", false, null)
      }
    },
    emptyFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyFontFamily", "emptyFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontFamily", false)
      }
    },
    emptyFontSize: {
      get() {
        return this.options.emptyFontSize || 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontSize", false)
      }
    },
    emptyFontWeight: {
      get() {
        return this.options.emptyFontWeight || 400
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontWeight", false)
      }
    },
    emptyFontColor: {
      get() {
        return this.options.emptyFontColor || "rgba(0, 0, 0, 0.4)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontColor", false)
      }
    },
    emptyImgSrc: {
      get() {
        return this.options.emptyImgSrc || this.defaultImgEmpty
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyImgSrc", false)
      }
    },
    emptyImgClipSize: {
      get() {
        return this.options.hasOwnProperty("emptyImgClipSize") ? this.options.emptyImgClipSize : "cover"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyImgClipSize", false)
      }
    },
    emptyImgRepeatType: {
      get() {
        return this.options.hasOwnProperty("emptyImgRepeatType") ? this.options.emptyImgRepeatType : "no-repeat"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyImgRepeatType", false)
      }
    },
    emptyImgAlignType: {
      get() {
        return this.options.hasOwnProperty("emptyImgAlignType") ? this.options.emptyImgAlignType : "left top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyImgAlignType", false)
      }
    },
    emptyImgWidth: {
      get() {
        return this.options.emptyImgWidth || 144
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyImgWidth", false)
      }
    },
    emptyImgHeight: {
      get() {
        return this.options.emptyImgHeight || 104
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyImgHeight", false)
      }
    },
    multiImageDetail() {
      return this.options.multiImageDetail
    },
    diffCategory: {
      get() {
        return this.options.categoryMode !== CATEGORY_MODE.SAME
      },
      set(newVal) {
        this.$changeOptionsEV(newVal ? CATEGORY_MODE.DIFF : CATEGORY_MODE.SAME, "categoryMode", false, null)
        // 切换为相同样式，只保留一份
        if(!newVal) {
          this.options.rows.splice(1)
        } else {
          // 切换为不同样式，需要根据tabsList的数量生成多份
          const rowLens = this.options.rows.length
          const tabLens = this.options.tabsList.length
          for(let i = 0; i < tabLens - rowLens; i++) {
            const tempRow = simpleDeepClone(this.options.rows[0])
            this.options.rows.push(tempRow)
          }
        }
      }
    },
  },
  created() {
    this.initSubPageSetting()
    if (this.options.menuName !== "搜索") {
      this.initTitleComponents()
      this.getPublicId()
      this.getDataPushData()
    }
  },
  mounted() {
    if (this.options.menuName === "移动端导航栏") {
      this.getAllDetailDataFunc()
    }
  },
  methods: {
    async getDataPushData() {
      if (!this.options.engineInstanceId_10) {
        return
      }
      let res = await this.$API.getDataPushRule({
        engineInstanceId: this.options.engineInstanceId_10
      })
      if (res.data.code === 1 && res.data.data?.interfacePushRule) {
        let data = res.data.data.interfacePushRule
        this.interfacePushRule.addAndUpdateRule = data.addAndUpdateRule
        this.interfacePushRule.engineInstanceId = data.engineInstanceId
        this.interfacePushRule.id = data.id
        this.interfacePushRule.method = data.method
        this.interfacePushRule.pushType = data.pushType
        this.interfacePushRule.status = data.status
        this.interfacePushRule.url = data.url
        this.editDataToPush = this.interfacePushRule.addAndUpdateRule.indexOf("2") > -1 ? true : false
        this.newDataToPush = this.interfacePushRule.addAndUpdateRule.indexOf("1") > -1 ? true : false
      }
    },
    initTitleComponents() {
      // 获取分类、更多、分页组件的真实显示位置elementOptions
      const titleOptions = this.options.titleOptions
      let classifyIndex, moreIndex
      for (let i = 0; i < titleOptions.length; i++) {
        //头部
        if (i === 0 && titleOptions[i].elementOptions.length === 1) {
          this.titleComponents[0].elementOptions.forEach(item => {
            item.isShow = false
          })
        }
        for (let j = 0; j < titleOptions[i].elementOptions.length; j++) {
          let itemObj = titleOptions[i].elementOptions[j]
          let titleElementOp = this.titleComponents[i].elementOptions
          const classificationObj = titleElementOp.find(item => item.type === "classification")
          const moreObj = titleElementOp.find(item => item.type === "more")
          const paginationObj = titleElementOp.find(item => item.type === "pagination")
          if (itemObj.type === "classification") {
            classifyIndex = i
            classificationObj.isShow = itemObj.isShow
            classificationObj.elementInLayoutId = itemObj.elementInLayoutId
            classificationObj.disabled = !itemObj.isShow
            classificationObj.showAllType = itemObj.showAllType
            // 增加特殊逻辑，如果分类不显示，则默认显示全部分类数据
            // if (!itemObj.isShow) {
            //   classificationObj.showAllType = true
            // }
          } else if (itemObj.type === "more") {
            moreIndex = i
            moreObj.isShow = itemObj.isShow
            moreObj.elementInLayoutId = itemObj.elementInLayoutId
            moreObj.disabled = !itemObj.isShow
          } else if (itemObj.type === "pagination") {
            paginationObj.isShow = itemObj.isShow
            moreObj.elementInLayoutId = itemObj.elementInLayoutId
            paginationObj.disabled = false // 分页组件只会存在下面
          }
          if (itemObj.isShow) {
            if (i !== 0 && (itemObj?.type === "classification" || itemObj?.type === "more")) {
              let obj1 = this.titleComponents[0].elementOptions.find(obj => obj.type === itemObj.type)
              obj1.isShow = false
              obj1.disabled = true
            }
          } else {
            if (i === 0 && (itemObj?.type === "classification" || itemObj?.type === "more")) {
              let obj1 = this.titleComponents[0].elementOptions.find(obj => obj.type === itemObj.type)
              obj1.isShow = false
              obj1.disabled = false
            }
          }
        }
      }
      let itemClassify = this.titleComponents[classifyIndex]?.elementOptions.find(
        item => item.type === "classification" && !item.isShow
      )
      if (itemClassify) {
        this.titleComponents.forEach(item1 => {
          let itemClassify2 = item1?.elementOptions.find(item2 => item2?.type === "classification")
          itemClassify2.disabled = false
        })
      }
      let itemMore = this.titleComponents[moreIndex]?.elementOptions.find(item => item.type === "more" && !item.isShow)
      if (itemMore) {
        this.titleComponents.forEach(item1 => {
          let itemMore2 = item1?.elementOptions.find(item2 => item2?.type === "more")
          itemMore2.disabled = false
        })
      }
    },
    checkMenuTriggerType(type) {
      const titleOption = this.options.titleOptions.find(item => item.type === (type === "L" ? "left" : "right"))
      const directionIndex = type === "L" ? 2 : 3
      for (let i = 0; i < titleOption.elementOptions.length; i++) {
        if (titleOption.elementOptions[i].innerElement.includes("Menu")) {
          const completeParam = {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: this.ids.path,
            directionIndex,
            elementInLayoutId: titleOption.elementOptions[i].elementInLayoutId,
            option_name: "menuTrigger",
            option_val: "click"
          }
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", completeParam)
        }
      }
    },
    initDrawerBtn(type) {
      const btn = JSON.parse(JSON.stringify(layout_title_drawer_button_children[0].attribute.options))
      console.log("btn :>> ", btn)
      btn.drawerPosition = type
      btn.isCustomComponent = true
      btn.name = type === "L" ? "左侧抽屉按钮" : "右侧抽屉按钮"
      btn.top = 0
      if (type === "L") {
        btn.left = 0
      } else {
        const rectElWidth = document.getElementsByClassName(
          this.$event.getIdsByStrId({
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id
          })
        )[0].offsetWidth
        btn.left = rectElWidth - btn.width
      }
      if (btn.hasOwnProperty("pluginName") === false) btn.pluginName = ["layoutTitleOptionDrawerPlugin"]
      else btn.pluginName.push("layoutTitleOptionDrawerPlugin")
      this.$store.dispatch(this.request_prefix + "/addComponentInLayoutAround", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path,
        direction: 0,
        elementOptions: btn
      })
    },
    delDrawerBtn(elementInLayoutId) {
      this.$store.dispatch(this.request_prefix + "/delLayoutAroundElement", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path,
        directionIndex: 0,
        elementInLayoutId
      })
    },
    collapseMouseDown($event, val) {
      if (
        $event.target.classList[0] === "el-collapse-item__header" ||
        $event.target.classList[0] === "el-collapse-item__arrow"
      ) {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    checkboxDisplayHandle(flag, direction, elementParam) {
      let titleOptions = JSON.parse(JSON.stringify(this.options.titleOptions))
      this.titleComponents[direction].elementOptions.find(
        it => it.elementInLayoutId === elementParam.elementInLayoutId
      ).isShow = flag
      // 当改变显示位置时，需要将其他的显示位置设置为不显示,当取消显示位置时，需要将其他的显示位置设置为显示
      this.titleComponents.forEach((element, i) => {
        if (i !== direction) {
          element.elementOptions.forEach((item, j) => {
            if (item.type === elementParam.type) {
              if (flag) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
          })
        }
      })
      const { directionIndex, elementInLayoutId } = findTabs(
        this.options,
        {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        elementParam.type
      )
      if (direction === directionIndex && elementParam.elementInLayoutId === elementInLayoutId) {
        // 说明是原来的位置，不需要改变
        titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === elementInLayoutId).isShow = flag
      } else if (this.options.titleOptions[directionIndex]) {
        // 说明是新的位置，需要改变
        const elementComponent = JSON.parse(
          JSON.stringify(
            this.options.titleOptions[directionIndex].elementOptions.find(
              it => it.elementInLayoutId === elementInLayoutId
            )
          )
        )
        if (elementComponent.isShow === true && direction !== directionIndex) return
        // 同时返回数组下标
        const elementComponentIndex = this.options.titleOptions[directionIndex].elementOptions.findIndex(
          it => it.elementInLayoutId === elementInLayoutId
        )
        titleOptions[directionIndex].elementOptions.splice(elementComponentIndex, 1) // 删除原来的位置
        titleOptions[direction].elementOptions.push(elementComponent) // 添加到新的位置并且需要更新elementInLayoutId
        if (titleOptions[direction].elementOptions.length > 1) {
          titleOptions[direction].elementOptions.sort((a, b) => a.elementInLayoutId - b.elementInLayoutId) // 排序
          const newElementInLayoutId =
            titleOptions[direction].elementOptions[titleOptions[direction].elementOptions.length - 1]
              .elementInLayoutId + 1 // 最后一个元素的位置加1
          elementComponent.elementInLayoutId = newElementInLayoutId
          titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === newElementInLayoutId).isShow = flag
        } else {
          titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === elementInLayoutId).isShow = flag
        }
      }
      // 更多按钮不能正确显示在左右两侧
      if (
        flag === true &&
        (direction === 2 || direction === 3) &&
        (elementParam.type === "more" || elementParam.type === "classification")
      ) {
        let options = titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options
        if (options.leftType != "%")
          titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options.left = 0
      }
      if (flag === true && (direction === 0 || direction === 1) && elementParam.type === "more") {
        let options = titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options
        if (options.leftType != "%") {
          if (this.request_prefix === "appStage") {
            titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options.left = 322
          } else {
            titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options.left = 660
          }
        }
      }
      if (elementParam.type === "pagination" && !this.options.multiImageDetail) {
        this.signPagination(flag)
      }
      // 新增逻辑，在非列表页的情况下，如果当前边栏中不显示分类组件，那么就不需要传分类id
      // for (let i = 0; i < titleOptions.length; i++) {
      //   if (titleOptions[i].elementOptions.length > 0) {
      //     const elementOptions = titleOptions[i].elementOptions
      //     for (let j = 0; j < elementOptions.length; j++) {
      //       if (elementOptions[j].type === "classification") {
      //         if (!elementOptions[j].isShow && !this.preComponent) {
      //           this.showAllTypeHandle(true, i, elementOptions[j])
      //         }
      //       }
      //     }
      //   }
      // }
      this.$changeOptionsEV(titleOptions, "titleOptions", false, false, false, true)
      if (direction === 1 && elementParam.type === "pagination") {
        if (flag === true) {
          this.bottomPaginationShow = true
        } else {
          this.bottomPaginationShow = false
        }
      }
    },
    // 分类开启显示全部分类数据
    showAllTypeHandle(flag, direction, elementParam) {
      this.titleComponents.forEach((element, i) => {
      element.elementOptions.forEach((item, j) => {
          if (item.type === elementParam.type) {
            if (flag) {
              item.showAllType = true
            } else {
              item.showAllType = false
            }
          }
        })
      })
      // 更新options
      const titleOptions = JSON.parse(JSON.stringify(this.options.titleOptions))
      if(titleOptions[direction].elementOptions.length > 0){
        let opt1 = titleOptions[direction].elementOptions.find(
            it => it.elementInLayoutId === elementParam.elementInLayoutId
        )
        if(opt1){
          opt1.showAllType = flag
        }
      }
      this.$changeOptionsEV(titleOptions, "titleOptions", false, false, false, true)
      this.showAllTypeInterface(flag).then(res => {
        if (res.data.code === 1) {
          // 通知列表更新数据
          this.$eventBus.$emit(`update-layout-data-eventBus-${this.ids.container_id}-${this.ids.rect_id}`, {
            updateAll: true
          })
        }
      })
    },
    // 是否显示全部分类数据
    showAllTypeInterface(showAllType) {
      return this.$API.updateAppAttr({
        param: {
          publicId: this.publicId,
          showAllType: showAllType
        }
      })
    },
    // 对开启了分页的应用做标记，预览页接口不走all-request
    signPagination(flag) {
      //  不再使用该属性，因为person属性是用来判断数据是否是实时数据的
      //  关闭分页的时候，做旧数据兼容，关闭以前开启的实时数据
      //  因为改功能未完善，中途需要发交互的版本，所以暂时屏蔽
      // if(flag){
      //   return
      // }
      this.$API
        .updateAppAttr({
          param: {
            publicId: this.publicId,
            person: flag
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            console.log("保存成功")
          }
        })
    },
    // 找到搜索组件
    findSearchComponent() {
      return this.context.$store.state.page.children[0].children.filter(rect => {
        return rect.options?.pluginName?.includes("searchComponentPlugin")
      })[0]
    },
    // 查看列表页
    editPageHandle(flag) {
      this.isListPageEditStatus = true
      requestIdleCallback(
        () => {
          // 兼容以前旧模版中的应用 没有子页面映射关系 取第一个模版
          if (this.subPageSettingIndex === -1) {
            this.subPageSettingIndex = 0
          }
          const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
          const { listPageId, listPageIsUseSystemTemplate } = subPage
          const { appId } = this.options
          this.getListPageUrl().then(async res => {
            if (!res.exit && !listPageIsUseSystemTemplate) {
              // 兼容历史数据，子页面不存在但是使用模板标识又为false
              if (!flag) {
                this.isListPageEditStatus = false
                return
              }
              // 不在该网站下, 需要创建自定义页面
              createSubPageHandle
                .call(this, appId, "listPage", listPageId)
                .then(res => {
                  if (res.code === 200) {
                    this.editPageHandle(false)
                  }
                })
                .catch(err => {
                  // 需要创建自定义页面
                  createSubPageHandle
                    .call(this, appId, "listPage")
                    .then(res => {
                      if (res.code === 200) {
                        this.editPageHandle(false)
                      }
                    })
                    .catch(err => {
                      this.isDetailPageEditStatus = false
                    })
                })
            } else {
              if (this.isDounbleEnd) {
                const pcSubPage = (this.$store.state.stage.page.subPages || []).find(
                  item => item.appId === this.options.appId
                )
                const appSubPage = (this.$store.state.appStage.page.subPages || []).find(
                  item => item.appId === this.options.appId
                )
                if (pcSubPage) {
                  window.localStorage.setItem("subPageSetting-" + appId + "-stage", JSON.stringify(pcSubPage))
                }
                if (appSubPage) {
                  window.localStorage.setItem("subPageSetting-" + appId + "-appStage", JSON.stringify(appSubPage))
                }
              } else {
                const subPage = this.$store.state[this.request_prefix].page.subPages[this.subPageSettingIndex]
                window.localStorage.setItem(
                  "subPageSetting-" + appId + "-" + this.request_prefix,
                  JSON.stringify(subPage)
                )
              }
              // pv表示处于预览模式
              let engineInstanceId = this.options.engineInstanceId
              if (this.isSearchComponent) {
                // 重新获取搜索的engineInstanceId
                const param = await this.getSearchParam()
                if (param.p) {
                  engineInstanceId = param.p
                }
              }
              const name = this.options.name
              const url = res.exit
                ? res.url + `&e=${engineInstanceId}&name=${name}`
                : res.url + `&e=${engineInstanceId}&name=${name}&pv=1`
              window.open(url, "_blank")
            }
          })
        },
        { timeout: 500 }
      )
    },
    // 查找列表页是否在当前网站下
    getListPageUrl() {
      const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
      const { listPageId, listPageIsUseSystemTemplate } = subPage
      const { appId, menuName } = this.options
      // 是否是系统页面
      let newUrl = replaceUrlParam(window.location.href, "p", listPageId)
      // 判断当前页面是否在该网站下
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      const { websiteId, pageId, sign, wfwfid, homePageId } = this.$store.state.states.getDataPageIds
      const hasEqualPage = this.pageType === "equalPage" ? true : false
      return this.$API
        .queryEditPageList({
          websiteId: websiteId,
          pageId: pageId
        })
        .then(res => {
          this.isListPageEditStatus = false
          if (res.data.code === 1) {
            const pageIdList = res.data.data.allPage.map(item => item.publicId)
            // 在该网站下
            newUrl = replaceUrlParam(newUrl, "hp", pageId) + `&a=${appId}`
            newUrl = hasEqualPage ? replaceUrlParam(newUrl, "ehp", homePageId) : newUrl
            const rectAttr = this.getRectAttribute(this.ids)
            const isSearchComponent = this.getOptions.pluginName?.includes("searchComponentPlugin")
            if (isSearchComponent) {
              const elementOptions = this.getOptions.rows[0].cols[0].elementOptions
              let inputComponent = elementOptions.find(item => item.searchType === "searchInput")
              if (!inputComponent) {
                const autoLayout = elementOptions.find(item => item.innerElement === "cxAutoLayout")
                if (autoLayout && autoLayout.elementOptions) {
                  inputComponent = autoLayout.elementOptions.find(item => item.searchType === "searchInput")
                }
              }
              const val = inputComponent?.inputValue
              newUrl = newUrl + `&searchKey=${val}`
            }
            if (menuName === '移动端导航栏') {
              window.localStorage.setItem("isNavComponent", true)
            } else {
              window.localStorage.removeItem("isNavComponent") //清除掉导航列表页的标识
            }
            const managerType = this.$store.state.states?.managerType
            newUrl = managerType == 1 ? replaceUrlParam(newUrl, "managerType", 1) : newUrl
            newUrl = hasEqualPage ? replaceUrlParam(newUrl, "hasEqualPage", hasEqualPage) : newUrl
            if (pageIdList.includes(listPageId)) {
              return {
                exit: 1,
                url: newUrl
              }
            } else {
              return {
                exit: 0,
                url: newUrl
              }
            }
          }
        })
        .catch(err => {
          this.isListPageEditStatus = false
        })
    },
    // 查看详情页
    editDetailPageHandle(flag) {
      // 空数据不能跳转
      if (this.navAllDataEmpty) {
        this.$message({
          type: "error",
          customClass: "msg_noIcon",
          duration: 3000,
          message: "请先到数据后台导入详情页数据"
        })
        return
      }
      this.isDetailPageEditStatus = true
      requestIdleCallback(
        () => {
          // 兼容以前旧模版中的应用 没有子页面映射关系 取第一个模版
          if (this.subPageSettingIndex === -1) {
            this.subPageSettingIndex = 0
          }
          const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
          const { detailPageId, detailPageIsUseSystemTemplate } = subPage
          const { appId } = this.options
          this.getDetailPageUrl().then(res => {
            if (!res.exit && !detailPageIsUseSystemTemplate) {
              // 兼容历史数据，子页面不存在但是使用模板标识又为false
              if (!flag) {
                this.isDetailPageEditStatus = false
                return
              }
              // 不在该网站下, 需要创建自定义页面
              createSubPageHandle
                .call(this, appId, "detailPage", detailPageId)
                .then(res => {
                  if (res.code === 200) {
                    this.editDetailPageHandle(false)
                  }
                })
                .catch(err => {
                  // 需要创建自定义页面
                  createSubPageHandle
                    .call(this, appId, "detailPage")
                    .then(res => {
                      if (res.code === 200) {
                        this.editDetailPageHandle(false)
                      }
                    })
                    .catch(err => {
                      this.isDetailPageEditStatus = false
                    })
                })
            } else {
              if (this.isDounbleEnd) {
                const pcSubPage = (this.$store.state.stage.page.subPages || []).find(
                  item => item.appId === this.options.appId
                )
                const appSubPage = (this.$store.state.appStage.page.subPages || []).find(
                  item => item.appId === this.options.appId
                )
                if (pcSubPage) {
                  window.localStorage.setItem("subPageSetting-" + appId + "-stage", JSON.stringify(pcSubPage))
                }
                if (appSubPage) {
                  window.localStorage.setItem("subPageSetting-" + appId + "-appStage", JSON.stringify(appSubPage))
                }
              } else {
                const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
                window.localStorage.setItem(
                  "subPageSetting-" + appId + "-" + this.request_prefix,
                  JSON.stringify(subPage)
                )
              }
              // pv表示处于预览模式
              let engineInstanceId = this.options.engineInstanceId
              if (this.isSearchComponent) {
                // 重新获取搜索的engineInstanceId
                engineInstanceId = res.engineInstanceId
              }
              const name = this.options.name
              const url = res.exit
                ? res.url + `&e=${engineInstanceId}&name=${name}`
                : res.url + `&e=${engineInstanceId}&name=${name}&pv=2`
              window.open(url, "_blank")
            }
          })
        },
        { timeout: 500 }
      )
    },
    // 查找详情页是否在当前网站下
    getDetailPageUrl() {
      const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
      const { detailPageId, detailPageIsUseSystemTemplate } = subPage
      const { appId } = this.options
      let newUrl = replaceUrlParam(window.location.href, "p", detailPageId)
      // 找到第一个分类的id
      let colsIds = []
      handleFindLayoutComponentAllUid(this.options.rows, colsIds)
      let { dataId } = handleFindLayoutComponentBoxOptions(this.options.rows, colsIds[0])
      let { engineInstanceId } = this.options
      let temp = 0
      try {
        const { directionIndex, elementInLayoutId } = findTabs(
          this.options,
          {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id
          },
          "classification"
        )
        temp = this.options.titleOptions[directionIndex].elementOptions.find(
          it => it.elementInLayoutId === elementInLayoutId
        ).options.tabsList[0].id
      } catch (error) {}
      let typeId = temp ? temp : 0
      // 判断当前页面是否在该网站下
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      const { websiteId, pageId, sign, wfwfid, homePageId } = this.$store.state.states.getDataPageIds
      const hasEqualPage = this.pageType === "equalPage" ? true : false
      return this.$API
        .queryEditPageList({
          websiteId: websiteId,
          pageId: pageId
        })
        .then(async res => {
          this.isDetailPageEditStatus = false
          if (res.data.code === 1) {
            const rectAttr = this.getRectAttribute(this.ids)
            const isSearchComponent = this.getOptions?.pluginName?.includes("searchComponentPlugin")
            if (isSearchComponent) {
              // let sign, shortEngineInstanceId, shortId
              // const searchList = await this.$API.querySearchEngineData({
              //   p: pageId,
              //   wfwfid: wfwfid,
              //   param: {
              //     p2: 1,
              //     p3: 1
              //   }
              // })
              // if (searchList && searchList.data && searchList.data.code === 1) {
              //   let data = searchList.data.data.dataList
              //   if (data.length > 0) {
              //     sign = data[0].sign
              //     shortEngineInstanceId = data[0].engineInstanceId
              //     shortId = data[0].id
              //   }
              // }
              // // 如果是来自于搜索列表页, 在列表页里面不会直接返回engineInstanceId和dataId, 需要用一个接口去进行兑换
              // const res = await this.$API.queryExchangeDetail({
              //   engineInstanceId: shortEngineInstanceId,
              //   sign: sign,
              //   dataId: shortId.split("_")[1]
              // })
              const param = await this.getSearchParam()
              if (param.p) {
                engineInstanceId = param.p
                typeId = param.t || 0
                dataId = param.d
              }
            }
            const pageIdList = res.data.data.allPage.map(item => item.publicId)
            // 在该网站下
            newUrl = replaceUrlParam(newUrl, "hp", pageId) + `&e=${engineInstanceId}&t=${typeId}&d=${dataId}&a=${appId}`
            const managerType = this.$store.state.states?.managerType
            newUrl = managerType == 1 ? replaceUrlParam(newUrl, "managerType", 1) : newUrl
            newUrl = hasEqualPage ? replaceUrlParam(newUrl, "hasEqualPage", hasEqualPage) : newUrl
            newUrl = hasEqualPage ? replaceUrlParam(newUrl, "ehp", homePageId) : newUrl
            if (pageIdList.includes(detailPageId)) {
              return {
                exit: 1,
                url: newUrl,
                engineInstanceId: engineInstanceId
              }
            } else {
              return {
                exit: 0,
                url: newUrl,
                engineInstanceId: engineInstanceId
              }
            }
          }
        })
        .catch(err => {
          this.isDetailPageEditStatus = false
        })
    },
    // 触发首页的保存
    saveDataHandle() {
      document.getElementById("savePage").click()
    },
    updateDataPushSet() {
      if (!this.openDataPush) {
        this.showDialogForDataPush = false
        // 未开启数据推动的时候无需保存
        return
      }
      this.$API
        .editDataPushRule({
          interfacePushRule: {
            ...this.interfacePushRule
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.showDialogForDataPush = false
            console.log("修改成功")
            this.interfacePushRule.id = res.data.data.interfacePushRule.id
          }
        })
    },
    // 高级设置
    highSet() {
      this.$API
        .updateAppAttr({
          param: {
            publicId: this.publicId,
            openSensitiveWords: this.openSensitiveWords,
            checkIp: this.openDataLimit ? this.checkIp : "",
            deliverMhParams: this.deliverMhParams
          }
        })
        .then(res => {
          if (res.data.code === 1) {
          }
        })
    },
    async getPublicId() {
      const rectAttr = this.getRectAttribute(this.ids)
      const appId = this.getOptions?.appId
      console.log("rectAttr :>>", rectAttr, appId)
      if (!appId) return
      this.publicId = this.getOptions.engineInstanceId
    },
    // 根据当前组件的appId找到page.subPageMapping对应的子页面设置
    async initSubPageSetting() {
      let index = this.$store.state[this.request_prefix].page?.subPages?.findIndex(
        item => item.appId === this.options.appId
      )
      console.log("initSubPageSetting index", index)
      let listPageTemplateId, detailPageTemplateId
      if (typeof index === "undefined" || index === -1) {
        // 需要进行有应用但是没有子页面数据的老数据兼容
        const rectAttr = this.getRectAttribute(this.ids)
        const isSearchComponent = this.getOptions.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = this.getOptions?.innerElement?.toLowerCase().includes("nav")
        await addSubPageMapping.call(this, this.options.appId, isSearchComponent, isNavComponent).then(res => {
          const currentIndex = this.$store.state[this.request_prefix].page?.subPages?.findIndex(
            item => item.appId === this.options.appId
          )
          index = currentIndex
          listPageTemplateId = this.$store.state[this.request_prefix].page?.subPages[currentIndex].listPageTemplateId
          detailPageTemplateId =
            this.$store.state[this.request_prefix].page?.subPages[currentIndex].detailPageTemplateId
          this.getSubpageInfo(listPageTemplateId, detailPageTemplateId)
        })
      } else {
        listPageTemplateId = this.$store.state[this.request_prefix].page?.subPages[index].listPageTemplateId
        detailPageTemplateId = this.$store.state[this.request_prefix].page?.subPages[index].detailPageTemplateId
        this.getSubpageInfo(listPageTemplateId, detailPageTemplateId)
      }
      this.subPageSettingIndex = index
    },
    // 获取当前子页面模版的Cover和title
    getSubpageInfo(listPageTemplateId, detailPageTemplateId) {
      this.getListSubpageInfo(listPageTemplateId)
      this.getDetailSubpageInfo(detailPageTemplateId)
    },
    getListSubpageInfo(listPageTemplateId) {
      this.$API
        .queryComponentContent({
          encId: listPageTemplateId
        })
        .then(res => {
          if (res.data.code === 1) {
            this.currentListPageCover = res.data.data.cover
            this.currentListPageTitle = res.data.data.title
          }
        })
    },
    getDetailSubpageInfo(detailPageTemplateId) {
      this.$API
        .queryComponentContent({
          encId: detailPageTemplateId
        })
        .then(res => {
          if (res.data.code === 1) {
            this.currentDetailPageCover = res.data.data.cover
            this.currentDetailPageTitle = res.data.data.title
          }
        })
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "top":
          this.explainTitle = "显示标题栏"
          this.explainTips = "在图文/文本列表的顶部，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-title.png")
          break
        case "left":
          this.explainTitle = "显示左侧栏"
          this.explainTips = "在图文/文本列表的左侧，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-left.png")
          break
        case "right":
          this.explainTitle = "显示右侧栏"
          this.explainTips = "在图文/文本列表的右侧，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-right.png")
          break
        case "bottom":
          this.explainTitle = "显示底部栏"
          this.explainTips = "在图文/文本列表的底部，用来放置分页、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-bottom.png")
          break
        case "more":
          this.explainTitle = "显示更多"
          this.explainTips = "在预览页点击点击【更多/查看更多】按钮后，就会进入展示全部数据的列表页"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-more.png")
          break
        case "classification":
          this.explainTitle = "显示分类"
          this.explainTips = "选择是否需要展示列表中数据的分类"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-tab.png")
          break
        case "pagination":
          this.explainTitle = "显示分页"
          this.explainTips = "选择是否需要展示列表中数据的总条数、总页数等"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-paging.png")
          break
        case "order":
          this.explainTitle = "数据生成顺序"
          this.explainTips =
            "手动指定数据生成顺序，例如排行榜需要指定中间单元格优先生成数据。注意，如果修改单元格行列数量，会将生成顺序恢复为“从左到右，从上到下”顺序。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-order.png")
          this.explainVideoSrc = ""
          break
        case "hide":
          this.explainTitle = "隐藏空白数据"
          this.explainTips =
            "开启后，编辑页里未返回数据的单元格会自动渲染第一条数据。方便在数据为空时，能够对单元格的样式进行调整。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/auto-hide.png")
          this.explainVideoSrc = ""
          break
        case "dataLimit":
          this.explainTitle = "数据访问限制"
          this.explainTips =
            "开启后，可对组件的访问条件进行设置，可选择登陆后访问、仅IP内可访问、IP内可访问、IP外需登录访问，不满足条件的用户将看到组件显示暂无数据"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        case "words":
          this.explainTitle = "敏感词审核"
          this.explainTips = "开启后，会对数据内容进行敏感词审核，如果审核不通过，数据将不会显示在组件中"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        case "MhParams":
          this.explainTitle = "携带系统参数"
          this.explainTips = "如需对接云舟数据源，请开启此开关，开启后，将自动携带系统参数。"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        case "open":
          this.explainTitle = "新页面打开"
          this.explainTips = "开启后，若点击对应的列表页，新页面将会在新窗口打开"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        case "empty":
          this.explainTitle = "数据为空时显示以下内容"
          this.explainTips = "勾选后，空数据时组件显示以下内容；不勾选时，空数据时组件为暂无数据"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        case "category":
          this.explainTitle = "组件分类样式独立"
          this.explainTips = "开启后，每个分类下的单元格配置和样式将独立设置以实现更加个性化的样式需求。"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        default:
      }
    },
    // 选中
    seletTempleteHandler(params) {
      if (params.type === "listPage") {
        this.currentListPageCover = params.cover
        this.currentListPageTitle = params.title
      } else {
        this.currentDetailPageCover = params.cover
        this.currentDetailPageTitle = params.title
      }
    },
    editCellOrder() {
      this.$store.commit("states/changeGeneralAttr", {
        valName: "isOrderPattern",
        val: true
      })
    },
    // 跳转到数据推送记录页面
    toDataPushPage() {
      window.open(`/engine2/admin/push-log/to-logs?engineInstanceId=${this.options.engineInstanceId_10}`, "_blank")
    },
    async getSearchParam() {
      const { pageId, wfwfid } = this.$store.state.states.getDataPageIds
      let sign, shortEngineInstanceId, shortId
      const searchList = await this.$API.querySearchEngineData({
        p: pageId,
        wfwfid: wfwfid,
        param: {
          p2: 1,
          p3: 1
        }
      })
      if (searchList && searchList.data && searchList.data.code === 1) {
        let data = searchList.data.data.dataList
        if (data.length > 0) {
          sign = data[0].sign
          shortEngineInstanceId = data[0].engineInstanceId
          shortId = data[0].id
        }
      }
      // 如果是来自于搜索列表页, 在列表页里面不会直接返回engineInstanceId和dataId, 需要用一个接口去进行兑换
      const res = await this.$API.queryExchangeDetail({
        engineInstanceId: shortEngineInstanceId,
        sign: sign,
        dataId: shortId ? shortId.split("_")[1] : ""
      })
      const param = res?.data
      if (param.code === 1) {
        return param.data
      }
      return {}
    },
    //  获取详情页数据
    async getAllDetailDataFunc() {
      // 获取所有数据 （分类参数不传），取第一条数据的id
      const { engineInstanceId } = this.options
      let res = await this.$API.queryClassifyData({
        t: 0,
        param: {
          e: engineInstanceId,
          sw: "",
          p2: 1,
          p: 1,
          ad: true,
          nv: true
        }
      })
      if (res && res.data?.code === 1 && res.data?.data?.datas?.datas) {
        if (res.data?.data?.datas?.datas?.length === 0) {
          this.navAllDataEmpty = true
        }
      }
    },
    // 检查侧边栏中，有没有列表页关键组件
    checkSubComponent(index, newVal) {
      const isSubComponent = this.options.titleOptions[index].elementOptions.find(
        item => item.innerElement === "cxNavMenuVertical" || item.innerElement === "cxBreadCrumbs"
      )
      if (this.$store.state[this.request_prefix].type === "listPage" && isSubComponent) {
        const appId = this.$store.state.states.getDataPageIds.appId
        let subPage = localStorage.getItem("subPageSetting-" + appId + "-" + this.request_prefix)
        if (!subPage) {
          return
        }
        subPage = JSON.parse(subPage)
        const hasNavMenu = this.options.titleOptions[index].elementOptions.find(
          item => item.innerElement === "cxNavMenuVertical"
        )
        if (hasNavMenu) {
          subPage.listPageSetting.showNavMenu = newVal
        }
        const hasBread = this.options.titleOptions[index].elementOptions.find(
          item => item.innerElement === "cxBreadCrumbs"
        )
        if (hasBread) {
          subPage.listPageSetting.showBreadCrumbs = newVal
        }
        localStorage.setItem("subPageSetting-" + appId + "-" + this.request_prefix, JSON.stringify(subPage))
        sessionStorage.setItem("isSubComponentDeleting", 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .padding0 ::v-deep .el-collapse-item__content {
  padding: 0 16px 0 16px !important;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--themeColor);
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:not(.disabledBtn):hover {
    background: var(--defaultButtonHover);
    cursor: pointer;
  }
  &.is_disabled {
    background: var(--defaultButtonHover);
  }
  .icon-portal-loading1 {
    display: inline-block;
    margin-right: 4px;
    transform: rotate(90deg);
    font-size: 14px;
    color: var(--topOperationAColor);
    vertical-align: middle;
    margin-top: -2px;
    animation: rotation 1s linear infinite;
    &:before {
      color: var(--topOperationAColor);
    }
  }
  &.disabledBtn {
    cursor: not-allowed;
    border: 1px solid var(--themeColorDisabled);
    color: var(--themeColorDisabled);
  }
}
.layoutConfig-card {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  .img-box {
    width: 100%;
    // height: 122px;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: top;
    background-size: contain;
    background-clip: padding-box;
    background-repeat: no-repeat;
    background-size: 100%;
    &[src=""] {
      opacity: 0;
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    gap: 9.13px;
    position: absolute;
    width: 100%;
    height: 42px;
    left: 0px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(14.6087px);
    .title {
      font-size: 13px;
      line-height: 18px;
      color: #000000;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 104px;
    }
    .desc {
      cursor: pointer;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #2b67ff;
      display: flex;
      align-items: center;
    }
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px 4px 12px;
    background: #fbfcfd;
    .title {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.8);
    }
    .btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #2b67ff;
      cursor: pointer;
    }
  }
  .config-content {
    padding: 12px 12px 0 12px;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
    .el-radio {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 0;
      white-space: pre-wrap;
    }
    .cx-check-box {
      display: inline-block;
    }
    .tips-btn {
      line-height: 20px;
      margin-top: 0;
    }
  }
}
.cover {
  height: 132px;
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.padding8 {
  padding: 8px 4px;
}
.col_li {
  padding: 6px 4px;
}
.col_li .el-checkbox {
  margin-right: 6px;
}
.syncCol_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 50px;
  height: 28px;
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}
.push-history-link {
  color: var(--themeColor);
  cursor: pointer;
}
.text_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
  .el-checkbox {
    margin-right: 4px;
  }
  ::v-deep .el-input .el-input__inner {
    background-color: var(--leftMenuBgColor);
  }
}
::v-deep.collapsible-item .item-body .image_content .content-item{
  line-height: inherit;
}
</style>
<style>
  .width200 {
    width: 200px;
  }
</style>
